import React from 'react';
import withBlockExtensions from '@plone/volto/helpers/Extensions/withBlockExtensions';
import Image from '@plone/volto/components/theme/Image/Image';
import type { MainImageBlockData } from './index';
import type { Content } from '@plone/types';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';

interface MainImageBlockViewProps {
  data: MainImageBlockData;
  className?: string;
  isEditMode?: boolean;
  style?: React.CSSProperties;
  content?: Content;
  properties?: Content;
  [key: string]: any;
}

const MainImageBlockView: React.FC<MainImageBlockViewProps> = ({
  data = {} as MainImageBlockData,
  className,
  style,
  isEditMode,
  content,
  properties,
  ...props
}) => {
  const title = data.title || '';
  const description = data.description || '';
  const altText = data.altText || '';
  const position = data.position || 'center';
  const size = data.size || 'm';
  const pageContent = content || properties;
  const previewImage = pageContent?.preview_image_link;

  if (!previewImage) {
    return isEditMode ? (
      <div className={cx('main-image-block', 'empty', className)} style={style}>
        <FormattedMessage
          id="Nenhuma imagem de preview encontrada na página."
          defaultMessage="Nenhuma imagem de preview encontrada na página. Adicione uma imagem de
          preview na página para exibir neste bloco.&nbsp;"
        />
      </div>
    ) : null;
  }

  const imageItem = previewImage;

  const displayTitle = title || '';
  const displayDescription = description || '';

  const safePosition =
    position && ['left', 'center', 'right', 'full'].includes(position)
      ? position
      : 'center';

  const sizeMapping = {
    s: 'small',
    m: 'medium',
    l: 'large',
  };

  const mappedSize = sizeMapping[size] || 'medium';
  const safeSize = mappedSize;

  return (
    <div
      className={cx(
        'main-image-block',
        `position-${safePosition}`,
        `size-${safeSize}`,
        className,
      )}
      style={style}
    >
      <div className="main-image-wrapper">
        <div className="main-image-container">
          {imageItem && (
            <Image
              item={imageItem}
              alt={
                altText ||
                displayTitle ||
                imageItem?.title ||
                'Imagem principal'
              }
              loading="eager"
              responsive={true}
              className="main-image"
            />
          )}
        </div>

        {(displayTitle || displayDescription) && (
          <div className="main-image-content">
            {displayTitle && (
              <h2 className="main-image-title">{displayTitle}</h2>
            )}
            {displayDescription && (
              <p className="main-image-description">{displayDescription}</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default withBlockExtensions(MainImageBlockView);
